import * as React from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useStore } from "stores/connect";
import AppConfig from "util/AppConfig";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import useTelemetrySettings from "logic/telemetry/useTelemetrySettings";
const getPostHogSettings = () => {
  const { host, api_key: key } = AppConfig.telemetry() || {};
  return {
    host,
    key
  };
};
const init = (key, host) => {
  posthog.init(key, {
    autocapture: false,
    api_host: host,
    capture_pageview: false,
    capture_pageleave: false,
    cross_subdomain_cookie: false,
    persistence: "cookie",
    strict_script_versioning: true
  });
  return posthog;
};
const TelemetryInit = ({ children }) => {
  const { host, key } = getPostHogSettings();
  const { currentUser } = useStore(CurrentUserStore);
  const { data: settings } = useTelemetrySettings({ enabled: !!currentUser });
  if (!(settings == null ? void 0 : settings.telemetry_enabled) || !host || !key) {
    return children;
  }
  return /* @__PURE__ */ React.createElement(PostHogProvider, { client: init(key, host) }, children);
};
export default TelemetryInit;
